module.exports = __webpack_public_path__ + "media/whale sharks/boat-69bb3ec3.jpg";